export const datatableTheme = {
  row: {
    selectedBackground: "{primary.color}",
    selectedColor: "#ffffff",
  },
};
